export const splitIntoColumns = <T>(items: T[], maxColumns: number = 4): T[][] => {
  if (!items.length || maxColumns < 1) {
    return []
  }

  const minItemsPerColumn = Math.floor(items.length / maxColumns)
  const columnsWithExtraItem = items.length % maxColumns

  const columns: T[][] = []
  let itemsUsed = 0

  for (let col = 0; col < maxColumns; col++) {
    const itemsInThisColumn = col < columnsWithExtraItem
      ? minItemsPerColumn + 1
      : minItemsPerColumn

    if (itemsInThisColumn <= 0 && col > 0) {
      break
    }

    columns.push(items.slice(itemsUsed, itemsUsed + itemsInThisColumn))
    itemsUsed += itemsInThisColumn
  }

  return columns
}
